import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface NewsItem {
  id: string;
  title_en: string;
  title_lv: string | null;
  title_ru: string | null;
  body_en: string | null;
  body_lv: string | null;
  body_ru: string | null;
  image_url: string | null;
  link_url: string | null;
  sort_order: number;
  published_at: string;
}

export function useNews() {
  const [news, setNews] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      const { data, error } = await supabase
        .from("news")
        .select("*")
        .eq("is_published", true)
        .order("sort_order", { ascending: true });

      if (!error && data) {
        setNews(data);
      }
      setLoading(false);
    };
    fetchNews();
  }, []);

  return { news, loading };
}
